import * as Rx from 'rxjs';
import * as RxOp from 'rxjs/operators';
import { getPosApiUrl, getAccessToken } from '../../utils/state';
import {
  createCloseout,
  fetchCurrentBatch,
  fetchCloseoutReport,
} from '../../utils/api/client';
import {
  closeoutAlertBarAction,
  fetchCurrentBatchSuccess,
  SUBMIT_CLOSEOUT_FORM,
  FETCH_CURRENT_BATCH_REQUEST,
  FETCH_CLOSEOUT_REPORT_REQUEST,
  createCloseoutSuccess,
  fetchCloseoutReportRequest,
  fetchCloseoutReportSuccess,
  closeoutModalAction,
} from './Closeout.state';
import { caughtError } from '../../utils/api/errorHandler';
import { replaceAlerts } from '../../components/alert-bar/AlertBar.state';
import { closeModal } from '../../components/modal/Modal.state';

const caughtCloseoutErrorCallback = (state) =>
  caughtError(closeoutAlertBarAction, 'Closeout Page Error:', state);

const createCloseoutParams = (state, payload) => ({
  url: getPosApiUrl(state),
  token: getAccessToken(state),
  method: 'POST',
  batch: payload,
});

export const closeoutErrorEpic = ({ errorMessage }) =>
  Rx.of(
    closeoutAlertBarAction(
      replaceAlerts({
        heading: 'Closeout Page Error',
        text: errorMessage,
        variant: 'error',
      }),
    ),
  );

export const createCloseoutEpic = (action$, state$) =>
  action$.ofType(SUBMIT_CLOSEOUT_FORM).pipe(
    RxOp.flatMap((action) =>
      Rx.from(
        createCloseout(createCloseoutParams(state$.value, action.payload)),
      ).pipe(
        RxOp.flatMap((response) =>
          Rx.of(
            createCloseoutSuccess(response.data),
            fetchCloseoutReportRequest(response.data),
          ),
        ),
        RxOp.catchError((err) =>
          caughtCloseoutErrorCallback(state$.value)(err),
        ),
      ),
    ),
  );

const fetchBatchParams = (state) => ({
  url: getPosApiUrl(state),
  token: getAccessToken(state),
});
export const fetchCurrentBatchEpic = (action$, state$) =>
  action$.ofType(FETCH_CURRENT_BATCH_REQUEST).pipe(
    RxOp.flatMap(() =>
      Rx.from(fetchCurrentBatch(fetchBatchParams(state$.value))).pipe(
        RxOp.flatMap((response) =>
          Rx.of(fetchCurrentBatchSuccess(response.data)),
        ),
        RxOp.catchError((err) =>
          caughtCloseoutErrorCallback(state$.value)(err),
        ),
      ),
    ),
  );

const fetchCloseoutReportParams = (state) => ({
  url: getPosApiUrl(state),
  token: getAccessToken(state),
});
export const fetchCloseoutReportEpic = (action$, state$) =>
  action$.ofType(FETCH_CLOSEOUT_REPORT_REQUEST).pipe(
    RxOp.flatMap(() =>
      Rx.from(
        fetchCloseoutReport(fetchCloseoutReportParams(state$.value)),
      ).pipe(
        RxOp.flatMap((response) =>
          Rx.of(
            closeoutModalAction(closeModal()),
            fetchCloseoutReportSuccess(response.data),
          ),
        ),
        RxOp.catchError((err) =>
          caughtCloseoutErrorCallback(state$.value)(err),
        ),
      ),
    ),
  );
